function AgentContact() {
    "use strict";
    this.__type = 'AgentContact:www.veritracks.com';
    this.Id = -1;
    this.UserId = -1;
    this.Message = '';
    this.Subject = '';
}
if (typeof exports !== 'undefined') {
    module.exports = AgentContact;
}